import { render } from "./status_content.vue?vue&type=template&id=f9bf460c"
import script from "./status_content.js?vue&type=script&lang=js&external"
export * from "./status_content.js?vue&type=script&lang=js&external"

import "./mfm.scss?vue&type=style&index=0&lang=scss&external"
import "./status_content.vue?vue&type=style&index=1&id=f9bf460c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__